import React, {useEffect, useState} from "react";
import jwtSimple from "jwt-simple";
import {
    TransferDashboardContainer,
    MetabaseIframe,
    LoadingIndicator,
    DashboardTitle
} from "./TransferDashboardStyles";
import {Loading} from "../../_defaultComponents/Loading/Loading";

const TransferDashboard = () => {
    const [iframeUrl, setIframeUrl] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        try {
            setLoading(true);
            const METABASE_SITE_URL = "https://report.vigo.ist";
            const METABASE_SECRET_KEY =
                "8158a1e0b5b62e73a196745ff66f2b16cc26226ac23ec6ea45afeba6fd51fc91";

            const payload = {
                resource: {dashboard: 5},
                params: {},
                exp: Math.round(Date.now() / 1000) + 10 * 60
            };

            const token = jwtSimple.encode(payload, METABASE_SECRET_KEY);
            const url = `${METABASE_SITE_URL}/embed/dashboard/${token}#background=false&bordered=false&titled=false`;
            setIframeUrl(url);
        } catch (error) {
            console.error("Metabase token oluşturulurken hata:", error);
        }
    }, []);

    return (
        <TransferDashboardContainer>
            <DashboardTitle>Dashboard</DashboardTitle>
            {loading && <LoadingIndicator />}
            <MetabaseIframe
                src={iframeUrl}
                height="800"
                allowtransparency="true"
                title="Metabase Dashboard"
                onLoad={() => {
                    setTimeout(() => {
                        setLoading(false);
                    }, 2000);
                }}
                style={{display: loading ? "none" : "block"}}
            />
        </TransferDashboardContainer>
    );
};

export default TransferDashboard;
